import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AboutSection } from './components/AboutSection';
import { QualificationsSection } from './components/QualificationsSection';
import { TherapistProfiles } from './components/TherapistProfiles';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <AboutSection data-id="element-4" />
        <QualificationsSection data-id="element-5" />
        <TherapistProfiles data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}